/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.RailzBillsResponse | undefined,
  (params: vp.RailzBillsOrInvoicesRequest) => void,
  (params: vp.RailzBillsOrInvoicesRequest) => Promise<vp.RailzBillsResponse>,
  () => void,
];

function useFetchRailzBills({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.RailzBillsOrInvoicesRequest>();
  const [response, setResponse] = useState<vp.RailzBillsResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.RailzBillsOrInvoicesRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchRailzBills(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.RailzBillsOrInvoicesRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.RailzBillsOrInvoicesRequest) => api.fetchRailzBills(requestParams, source),
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchRailzBills);
